// language=GraphQL
export const ALL_CATEGORIES_QUERY = `query Query($withPages: Boolean = false, $withPagesSeoSettings: Boolean = false, $withPagesSeoSettingsOgImage: Boolean = false, $withPagesContentBlockAssignments: Boolean = false, $withPagesContentBlockAssignmentsBlock: Boolean = false, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false) {
  categories: cmsCategories {
    id
    name
    pages @include(if: $withPages) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withPagesSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withPagesSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withPagesContentBlockAssignments) {
        id
        type
        block @include(if: $withPagesContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
        }
      }
    }
    seoSettings @include(if: $withSeoSettings) {
      id
      urlSlug
      metaTitle
      metaDescription
      ogTitle
      ogDescription
      ogImage @include(if: $withSeoSettingsOgImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_CATEGORY_QUERY = `query Query($id: ID!, $withPages: Boolean = false, $withPagesSeoSettings: Boolean = false, $withPagesSeoSettingsOgImage: Boolean = false, $withPagesContentBlockAssignments: Boolean = false, $withPagesContentBlockAssignmentsBlock: Boolean = false, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false) {
  category: cmsCategory(id: $id) {
    id
    name
    pages @include(if: $withPages) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withPagesSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withPagesSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withPagesContentBlockAssignments) {
        id
        type
        block @include(if: $withPagesContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
        }
      }
    }
    seoSettings @include(if: $withSeoSettings) {
      id
      urlSlug
      metaTitle
      metaDescription
      ogTitle
      ogDescription
      ogImage @include(if: $withSeoSettingsOgImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }
}`

// language=GraphQL
export const CREATE_CATEGORY_MUTATION = `
  mutation Mutation($input: CreateCmsCategoryInput, $withPages: Boolean = false, $withPagesSeoSettings: Boolean = false, $withPagesSeoSettingsOgImage: Boolean = false, $withPagesContentBlockAssignments: Boolean = false, $withPagesContentBlockAssignmentsBlock: Boolean = false, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false) {
    category: createCmsCategory(input: $input) {
      id
      name
      pages @include(if: $withPages) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withPagesSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withPagesSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withPagesContentBlockAssignments) {
          id
          type
          block @include(if: $withPagesContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              phone
              email

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
          }
        }
      }
      seoSettings @include(if: $withSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_CATEGORY_MUTATION = `
  mutation Mutation($input: UpdateCmsCategoryInput, $withPages: Boolean = false, $withPagesSeoSettings: Boolean = false, $withPagesSeoSettingsOgImage: Boolean = false, $withPagesContentBlockAssignments: Boolean = false, $withPagesContentBlockAssignmentsBlock: Boolean = false, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false) {
    category: updateCmsCategory(input: $input) {
      id
      name
      pages @include(if: $withPages) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withPagesSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withPagesSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withPagesContentBlockAssignments) {
          id
          type
          block @include(if: $withPagesContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              phone
              email

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
          }
        }
      }
      seoSettings @include(if: $withSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_CATEGORY_MUTATION = `
  mutation Mutation($input: DeleteCmsCategoryInput) {
    deleteCmsCategory(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_CATEGORY_MUTATION = `
  mutation Mutation($input: DeleteCmsCategoryInput) {
    forceDeleteCmsCategory(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_CATEGORY_PAGES_MUTATION = `
  mutation Mutation($input: addCmsCategoryPagesInput) {
    addCmsCategoryPages(input: $input) {
      id
      pageIds
    }
  }`

// language=GraphQL
export const REMOVE_CATEGORY_PAGES_MUTATION = `
  mutation Mutation($input: removeCmsCategoryPagesInput) {
    removeCmsCategoryPages(input: $input) {
      id
      pageIds
    }
  }`

// language=GraphQL
export const CREATE_CATEGORY_PAGES_MUTATION = `
  mutation Mutation($input: createCmsCategoryPagesInput) {
    createCmsCategoryPages(input: $input) {
      id
      pageIds
    }
  }`

// language=GraphQL
export const DELETE_CATEGORY_PAGES_MUTATION = `
  mutation Mutation($input: deleteCmsCategoryPagesInput) {
    deleteCmsCategoryPages(input: $input) {
      id
      pageIds
    }
  }`

// language=GraphQL
export const UPDATE_CATEGORY_PAGES_ORDER_MUTATION = `
  mutation Mutation($input: updateCmsCategoryPagesOrderInput) {
    updateCmsCategoryPagesOrder(input: $input) {
      id
      pageIds
    }
  }`

// language=GraphQL
export const CATEGORIES_DEPENDENTS_QUERY = `query Query($id: ID!, $withTenantCms: Boolean = false) {
  groupedDependents: cmsCategoryDependents(id: $id) {
    tenantCms @include(if: $withTenantCms) {
      id
    }
  }
}`
